var map = {
	"./de/general2/slide2.svg": 340132,
	"./en/general2/slide2.svg": 67152,
	"./es/general2/slide2.svg": 385869,
	"./fr/general2/slide2.svg": 419397,
	"./nl/general2/slide2.svg": 774623,
	"./pt/general2/slide2.svg": 439553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 490204;